import Foundation from 'foundation-sites/dist/js/foundation.min'; // due to foundation es6 issues...
import axios from 'axios';
import qs from 'qs';
import Vue from 'vue';
import VueMq from 'vue-mq';
import L from 'leaflet';
import style from '../../components/general/elements/style';
import FileDownload from 'js-file-download';
import * as setup from '../../setup';
import mapLeaflet from '../general/map-leaflet';

const CancelToken = axios.CancelToken;
const MaxZoomLevel = 12;
let cancel;
let typeTimer = null;

Vue.use(VueMq, {
    breakpoints: {
        sm: 450,
        md: 1250,
        lg: Infinity,
    }
});

export default Vue.component('servicepointsearch', {
    components: {
        'leaflet-map': mapLeaflet
    },
    data: function () {
        return {
            address: '',
            isSearching: false,
            selectedIndex: null,
            results: [],
            radiusDistance: 20,
            mapCenter: null,
            mapInitialized: false,
            resultListIsOpen: true,
            showFilters: true,
            showPanel: true
        };
    },
    watch: {
        selectedUserType: function (newValue) {
            if (+newValue === 0) {
                if (!this.selectedWasteTypes.includes(8)) {
                    this.selectedWasteTypes.push(8)
                }
            }
            else{
                if (this.selectedWasteTypes.includes(8)) {
                    const selectedWasteTypeIndex = this.selectedWasteTypes.findIndex((wasteType) => wasteType === 8)
                    if (selectedWasteTypeIndex >= 0) {
                        this.selectedWasteTypes.splice(selectedWasteTypeIndex, 1)
                    }
                }
            }
        },
    },
    methods: {
        /** Transforms the LatLngBounds object into BoundModel object */
        transformMapBounds(mapBounds) {
            if (mapBounds === undefined)
                return null;

            return {
                SouthWest: { Latitude: mapBounds.getSouth(), Longitude: mapBounds.getWest() },
                NorthEast: { Latitude: mapBounds.getNorth(), Longitude: mapBounds.getEast() }
            }
        },
        /** Transforms the map center object into LocationModel object */
        transformMapCenter(mapCenter) {
            return mapCenter !== undefined ? { Latitude: mapCenter.lat, Longitude: mapCenter.lng } : null;
        },
        /** Builds the search parameters object */
        buildSearchParameters(mapBounds, mapCenter) {
            let searchParameters = {
                Address: this.address,
                RadiusDistance: this.radiusDistance,
                UserType: this.selectedUserType,
                WasteTypes: this.selectedWasteTypes,
                // CollectionWall: this.collectionWall,
                MapBound: this.transformMapBounds(mapBounds),
                Location: this.transformMapCenter(mapCenter)
            };

            return searchParameters;
        },
        /** build the marker for a service point */
        buildMarker(servicePoint) {

            let marker = null;

            let icon = L.divIcon({
                className: servicePoint.municipalityServicePoint ? 'map-icon map-icon--municipality' : 'map-icon',
                iconSize: L.point(40, 40),
                iconAnchor: [20, 40]
            });

            if (servicePoint != null) {
                marker = L.marker([servicePoint.lat, servicePoint.lon], {
                    icon: icon,
                    title: servicePoint.name,
                });

                marker.on('click', e => {
                    this.showServicePointInfo(servicePoint);
                });
            }

            return marker;
        },
        unHighlightServicePointInfo(servicePoint){
            servicePoint.marker._icon ? servicePoint.marker._icon.classList.remove('hovering') : null;
        },
        highlightServicePointInfo(servicePoint){
            servicePoint.marker._icon ? servicePoint.marker._icon.classList.add('hovering') : null;
        },
        /** shows the service point map marker info window */
        showServicePointInfo(servicePoint) {
            this.selectedIndex = servicePoint.index;
            let popUp = this.$refs.mapcomponent.showInfoWindow(servicePoint);

            // Click event for report feedback button
            $(popUp._container).on('click', 'button[data-feedback]', e => {
                this.openFeedbackModal(servicePoint);
            });

            // Reset selected index when closing info popup
            $(popUp._closeButton).on('click', e => {
                this.selectedIndex = null;
            });
        },
        /** Downloads the service point ssds if available */
        downloadSSDSFile(servicePoint) {
            if (servicePoint.hasSSDSFile) {
                this.axe.get('/DownloadSSDSFile', { params: { servicePointId: servicePoint.id } })
                    .then((response) => { FileDownload(response.data, servicePoint.sSDSFileName); })
                    .catch((error) => { console.log('Error downloading ssds file : ' + error); });
            }
        },
        /** Handler for when the map boundaries has changed (on zoom, setCenter, drag end, initial render, etc) */
        onMapChanged(mapBounds) {
            this.performSearch(mapBounds);
        },
        /** Performs the search action using the specified map boundaries */
        performSearch(mapBounds) {

            // Prevent too zoomed out calls
            if (this.$refs.mapcomponent.zoomLevel < MaxZoomLevel) {

                // Clear results
                this.results = [];
                // Clear markers
                this.$refs.mapcomponent.clearMarkers();
                // Clear popups
                this.$refs.mapcomponent.map.closePopup();
                
                return;
            }

            let mapCenter = this.$refs.mapcomponent.getMapCenter();
            let searchParameters = this.buildSearchParameters(mapBounds, mapCenter);

            // Cancel any previous call
            cancel && cancel('cancelled because of subsequent calls');

            this.axe.get('/Search', { params: searchParameters, cancelToken: new CancelToken((c) => { cancel = c }) })
                .then((response) => {
                    
                    this.results = response.data.resultItems || [];

                    if (this.results.length > 0) {
                        this.showFilters = false; // Close filters
                        this.selectedIndex = null; // Clear selected index
                    }

                    this.results = this.results.map((item, index) => {
                        item.index = index; // Add index
                        item.marker = this.buildMarker(item); // Build markers for map
                        item.wasteTypes = item.wasteTypes.filter(wt => wt.type !== 5); // Filter wasteTypes to exclude "Armaturen"

                        return item;
                    });

                    this.$refs.mapcomponent.showMarkers(this.results.map(r => { return r.marker }));
                })
                .catch((error) => {
                    console.log('Error retrieving page data : ' + error);
                });
        },
        /** Handler for search input. Just get new map center based on the specified address. */
        searchByAddress() {

            // Set address to ref value
            this.address = this.$refs.address.value;

            // First center map on address
            this.retrieveMapCenter();
        },
        /** Handler for search with current location */
        searchByCurrentLocation() {
            this.getCurrentLocation((location) => {
                this.$refs.mapcomponent.centerMap(L.latLng(location.coords.latitude, location.coords.longitude));
            }, (errorMessage) => {
                console.log('Failure to retrieve current location : ' + errorMessage.message);
            });
        },
        /** Retrieves the current location, and executes the specified handlers. */
        getCurrentLocation(onSuccessHandler, onFailureHandler) {
            navigator.geolocation.getCurrentPosition(onSuccessHandler, onFailureHandler, { maximumAge: 5 * 60 * 1000 });
        },
        /** retrieves the initial map center based on the current search parameters */
        retrieveMapCenter() {

            // clear markers
            this.$refs.mapcomponent.clearMarkers();
            // clear popups
            this.$refs.mapcomponent.map.closePopup();

            if (this.address === "" || this.address === null) {
                // center map with default values
                this.$refs.mapcomponent.centerMap(undefined, 8);

                // clear results
                this.results = [];
                
                return;
            }

            let searchParameters = this.buildSearchParameters();

            this.axe.get('/GetMapCenter', { params: searchParameters })
                .then((response) => {
                    //this.mapCenter = new google.maps.LatLng(response.data.mapCenter.latitude, response.data.mapCenter.longitude);
                    this.mapCenter = L.latLng(response.data.mapCenter.latitude, response.data.mapCenter.longitude);
                })
                .then(() => { this.$refs.mapcomponent.centerMap(this.mapCenter); })
                .catch((error) => {
                    console.log('Error retrieving map center : ' + error);
                });
        },
        openWasteTypeInfoModal() {
            let wasteTypeInfoModal = $('#wasteTypeInfoModal');
            wasteTypeInfoModal.foundation('open');
        },
        openProfessionalDeviceModal() {
            let professionalDeviceModal = $('#professionalDeviceModal');
            professionalDeviceModal.foundation('open');
        },
        openFeedbackModal(servicePoint) {

            // Empty any previously opened modals
            let feedbackModal = $('#feedbackModal');
            feedbackModal.html();

            // Create parameters object
            let parameters = {
                servicePointId: servicePoint.id,
                servicePointName: servicePoint.name
            };

            let axe = this.axe;

            // Get modal html
            axe.get('/ReportFeedbackModal', { params: parameters }).then((response) => {

                // Fill modal content
                feedbackModal.html(response.data).foundation('open');

                // Initialize Google recaptcha
                grecaptcha.render('g-recaptcha', {
                    'sitekey': '6Ld75GcbAAAAAHU7TOSdkggyMupa8XU5EJymeC0J'
                });

                // Initialize custom file validator
                Foundation.Abide.defaults.validators['file'] = function (el, required, parent) {

                    let files = el[0].files;

                    if (files != null && files.length) {

                        let validFiles = false;

                        $.each(files, function () {

                            const acceptedFileTypes = [
                                'application/pdf', // pdf
                                'application/vnd.ms-excel', // xsl
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // xslx
                                'image/jpeg', // jpg images
                                'image/png', // png images
                                'application/msword', // doc
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // docx
                            ];

                            // on top of filetype array, also allow .msg extension
                            let acceptedFileType = ($.inArray(this.type, acceptedFileTypes) > -1 || this.name.indexOf('.msg') > -1);

                            if (this.name === 'item' || typeof this.name === 'undefined') {
                                // file(name) not approved
                                validFiles = false;
                                return;
                            } else if (!acceptedFileType) {
                                // filetype not accepted
                                validFiles = false;
                                return;
                            } else if (((this.size / 1024).toFixed(2)) > 2048) {
                                // file too big
                                validFiles = false;
                                return;
                            }

                            validFiles = true;
                            return;
                        });

                        return validFiles;
                    } else {
                        // No files uploaded, return valid
                        return true;
                    }
                };

                // Initialize form validation
                let feedbackForm = feedbackModal.find('form');
                let feedbackFormValidation = new Foundation.Abide(feedbackForm, {
                    liveValidate: true,
                    validateOnBlur: true
                });

                feedbackForm.on('formvalid.zf.abide', function (e, form) {

                    let grecaptchaResponse = grecaptcha.getResponse();

                    if (grecaptchaResponse.length > 0) {

                        // Post to controller action and handle response
                        axe.post('/ReportFeedback', new FormData(form[0]), {
                            headers: { 'Content-Type': 'multipart/form-data' }
                        }).then((response) => {
                            feedbackForm.replaceWith(response.data.message);
                        }).catch((response) => {
                            feedbackForm.replaceWith(response.data);
                        }).finally(function () {
                            return false;
                        });
                    }
                });

                feedbackForm.on('submit', function (e) {
                    e.preventDefault();
                });

                let subjectType = feedbackForm.find('#SubjectTypeId');
                let subject = feedbackForm.find('#SubjectId');

                // Update subjects list on change of subject type
                subjectType.on('change', function (e) {

                    if (e.target.value != '') {

                        // Create parameters object
                        let parameters = {
                            SubjectTypeId: e.target.value
                        };

                        // Get subjects for subject type
                        axe.get('/GetFeedbackSubjects', { params: parameters }).then((response) => {

                            // Clear existing subjects list
                            subject.empty();

                            // Append new subjects
                            $.each(response.data, function () {
                                subject.append($('<option />').val(this.value).text(this.text));
                            });
                        });
                    } else {

                        // Clear existing subjects list
                        subject.empty();
                    }
                });

                let anonymousFeedback = feedbackForm.find('#AnonymousFeedback');
                let optionalInputs = feedbackForm.find('#ReporterName, #ReporterEmailAddress, #Consent');
                let optionalLabels = feedbackForm.find('label[for="ReporterName"], label[for="ReporterEmailAddress"], label[for="Consent"]');

                // Hide / show fields based on anonymous feedback switch
                anonymousFeedback.on('change', function (e) {

                    // Toggle visibility of all optional fields and set abide ignore attribute
                    optionalInputs.toggle();
                    optionalLabels.toggle();

                    if (e.target.checked) {
                        // Ignore optional inputs when validation
                        optionalInputs.val('').prop('checked', false);
                        optionalInputs.attr('data-abide-ignore', e.target.checked);
                    } else {
                        // Enable validation again on inputs
                        optionalInputs.removeAttr('data-abide-ignore');
                    }
                });

                // Change file input label to show file names / file count when multiple
                let fileInput = feedbackForm.find('#Attachments');
                let label = fileInput[0].nextElementSibling;
                let labelVal = label.innerHTML;

                fileInput.on('change', function (e) {
                    var fileName = '';

                    if (this.files && this.files.length > 1) {
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                    } else {
                        fileName = e.target.value.split('\\').pop();
                    }

                    if (fileName) {
                        label.innerHTML = fileName;
                    } else {
                        label.innerHTML = labelVal;
                    }
                });
            });
        },
    },
    created() {
        this.axe = axios.create({
            baseURL: this.baseUrl,
            paramsSerializer: function (params) {
                return qs.stringify(params, { indices: false, allowDots: true })
            }
        });
        
        if (this.$isEmbedded) {
            this.showFilters = false;
        }
    },
    mounted() {
        // Focus on address input on page load
        this.$refs.address.focus();

        // Clear address when moving map
        this.$root.$on('clearAddress', function() {
            this.address = undefined;
        });

        // Set location if passed as query parameter
        if (this.$urlParameters && this.$urlParameters.has('location')) {
            this.address = this.$urlParameters.get('location');
            this.searchByAddress();
        }
    }
});